<template>
    <Header></Header>
    <main>
        <WrapperPage>
            <template #left>
                <BannerAutorization></BannerAutorization>
            </template>
            <template #right>
                <WrapperForm></WrapperForm>
            </template>
        </WrapperPage>
    </main>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import WrapperPage from "@/components/UserGroups/WrapperPage.vue"
import BannerAutorization from "@/components/UserGroups/BannerAutorization.vue"
import WrapperForm from "@/components/UserGroups/Registration/WrapperForm.vue"
export default {
    components: {
        Header,
        WrapperPage,
        BannerAutorization,
        WrapperForm
    }
}
</script>

<style scoped>

</style>